var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle2, _circle3, _path19, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path20, _path21, _path22, _path23, _path24, _rect, _rect2, _circle14, _circle15, _circle16, _circle17, _circle18, _rect3, _rect4, _rect5, _rect6, _rect7, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGetStarted1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 319 382",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 177,
  r: 142,
  fill: "#EFF3F9"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M134.484 326.511c-19.814-14.026-79.274-41.406-82.313-136.379 36.015 13.51 102.899 59.7 82.313 136.379Z",
  fill: "#83AB5B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M136.066 325.505c-16.714 6.756-57.68 32.933-118.254-3.268 22.892-17.089 78.591-40.358 118.254 3.268ZM133.831 311.276c-8.852-15.705-40.085-52.959-11.985-117.69 19.893 20.501 50.141 72.74 11.985 117.69Z",
  fill: "#83AB5B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m56.515 196.521 75.086 115.933M122.692 201.583l16.34 86.463M22.263 321.655l108.369 2.135M53.532 306.001l13.472 16.869-13.101 13.712M88.697 304.517l7.421 18.179-20.681 18.466M75.423 272.43l32.707 4.325M100.576 220.49l-4.29 36.687M57.327 228.538l21.45 2.101 2.441-24.484M124.426 260.87l-3.296 34.81M114.728 214.605l12.752 15.223 11.685-11.281M130.842 249.3l15.646-13.307",
  stroke: "#000",
  strokeWidth: 1.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m227.812 123.495-25.989-19.825 7.194-17.026c4.622 5.123 14.851 16.28 18.795 19.928 4.929 4.558 15.6-7.621 20.981-12.21 5.381-4.59 8.774-13.111 11.739-19.738 1.234-1.234 3.159-1.728.987 6.17 1.893-4.03 5.332-9.773 3.949-.493.905-2.386 2.716-6.27 2.716-2.715-.083 1.316-.593 4.344-1.975 5.924-1.321 4.948-5.466 16.477-11.484 23.012-8.037 12.262-21.651 15.595-26.913 16.973Z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m179.327 61.78 6.911-24.682 15.797 5.923-4.443 22.955-18.265-4.196ZM135.393 316.758v-17.525l16.043-1.974v19.499h-16.043ZM169.208 306.144l6.911-15.303 16.537 6.171-8.145 16.537-15.303-7.405Z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M129.716 304.91c-1.975-20.338 19.746-136.657 30.853-192.275l45.909 2.962c9.215 34.967 27.644 107.615 27.644 118.475s-23.695 54.877-35.542 75.528l-27.151-19.499c9.215-18.183 27.546-55.486 27.151-59.238-.395-3.751-6.911-61.294-10.12-89.596L165.258 304.91h-35.542Z",
  fill: "#FFC327"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m122.311 99.307 27.151-22.215 15.303 10.367c-5.924 3.538-18.858 11.403-23.202 14.563-5.43 3.949 4.443 16.784 7.899 22.954 3.455 6.171 10.613 1.234 16.537 5.43 1.892.988 5.183 2.962 3.208 2.962-1.974 0-4.936-1.152-6.17-1.728 2.139 1.07 6.269 3.308 5.677 3.703-.741.493-3.949 0-6.418-.741-2.468-.74 4.937 2.962 3.703 3.456-1.234.494-4.196-1.481-6.664-1.481-2.469 0-4.196.987-5.677.987-1.481 0 5.677.494 4.689 1.481-.987.987-2.962 1.481-7.404 0-3.555-1.185-11.33-7.707-14.773-10.82-10.299-10.241-13.532-23.525-13.859-28.918Z",
  fill: "#fff"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m122.311 99.307 27.151-22.215 15.303 10.367c-5.924 3.538-18.858 11.403-23.202 14.563-5.43 3.949 4.443 16.784 7.899 22.954 3.455 6.171 10.613 1.234 16.537 5.43 1.892.988 5.183 2.962 3.208 2.962-1.974 0-4.936-1.152-6.17-1.728 2.139 1.07 6.269 3.308 5.677 3.703-.741.493-3.949 0-6.418-.741-2.468-.74 4.937 2.962 3.703 3.456-1.234.494-4.196-1.481-6.664-1.481-2.469 0-4.196.987-5.677.987-1.481 0 5.677.494 4.689 1.481-.987.987-2.962 1.481-7.404 0M254.725 106.522c-8.037 12.262-21.651 15.595-26.913 16.973l-25.989-19.825 7.194-17.026c4.622 5.123 14.851 16.28 18.795 19.928 4.929 4.558 15.6-7.621 20.981-12.21 5.381-4.59 8.774-13.111 11.739-19.738 1.234-1.234 3.159-1.728.987 6.17 1.893-4.03 5.332-9.773 3.949-.493.905-2.386 2.716-6.27 2.716-2.715-.083 1.316-.593 4.344-1.975 5.924",
  stroke: "#000",
  strokeWidth: 1.5
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M209.44 46.477c7.898-3.95 7.898-20.486 4.936-26.657-.329-1.07-1.876-3.752-5.43-5.924-4.443-2.715-12.588-.247-18.265.494-4.542.592-5.183 9.462-4.936 13.822-.165-.165-.79-.691-1.975-1.48-4.69-2.963-11.107 2.961-7.652 9.378 2.765 5.134 7.899 2.798 10.12.988 4.443 11.6 15.303 13.328 23.202 9.379Z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M209.44 46.477c7.898-3.95 7.898-20.486 4.936-26.657-.329-1.07-1.876-3.752-5.43-5.924-4.443-2.715-12.588-.247-18.265.494-4.542.592-5.183 9.462-4.936 13.822-.165-.165-.79-.691-1.975-1.48-4.69-2.963-11.107 2.961-7.652 9.378",
  stroke: "#000",
  strokeWidth: 1.5
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M193.643 23.276c.197 5.529-5.183 5.759-7.898 5.183-.083-.247-.692-.987-2.469-1.975-1.777-.987-3.537-.74-4.196-.493-.905-2.468-2.616-9.133-2.221-16.044.395-6.91 6.746-6.993 9.873-6.17.411-.576 1.925-1.926 4.69-2.715 12.341-2.962 18.264 3.949 20.733 5.183 2.468 1.234 6.17-.494 6.17 0-.395.987-2.468 1.563-3.455 1.728 1.974.79 4.443.329 5.43 0 .411.493-.099 2.813-5.43 8.145-5.332 5.331-17.031 1.728-22.214-.74.247.329.79 2.369.987 7.898Z",
  fill: "#FF9078"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M184.017 57.584c-5.529-9.873-24.353 6.417-33.074 15.797l-3.95 3.949c3.95.395 10.696 10.86 13.576 16.044 10.119-7.817 28.977-25.917 23.448-35.79Z",
  fill: "#65A0F1"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M209.193 73.134c-3.752-10.663-18.183-13.493-24.929-13.575-3.127 1.48-10.219 4.887-13.576 6.664-13.032 20.338-15.961 43.03-15.796 51.833 13.229 9.478 43.194 8.063 56.522 6.171.823-12.588 1.531-40.43-2.221-51.093Z",
  fill: "#65A0F1"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M199.929 59.932c-11.314.15-5.974 24.466-1.889 36.604l1.587 5.355c2.231-3.283 14.647-4.222 20.576-4.28-2.043-12.623-8.959-37.83-20.274-37.68Z",
  fill: "#65A0F1"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M153.904 314.783h-20.239l-1.234 23.942c17.195 1.646 51.734 3.505 52.326-2.221.593-5.727-20.322-12.917-30.853-15.797v-5.924Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.532
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "m169.207 301.455-4.196 8.145-14.315 9.873 9.132 18.265c10.943 1.728 34.753 4.146 42.454 0 7.701-4.147-8.639-8.968-17.772-10.86l-1.234-7.405 4.937-6.171-19.006-11.847Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.532
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M183.276 30.69c-1.563-.988-4.64-2.173-4.442.987.246 3.949 1.974 3.702 4.442 3.455M208.452 26.247c0 2.303.297 7.108 1.481 7.898 1.185.79-.493 1.81-1.481 2.222",
  stroke: "#000",
  strokeWidth: 1.5
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M209.594 40.769c-1.548 1.533-4.992.838-6.521.3.091.447.762 1.473 2.726 1.992 2.454.65 4.192-2.245 3.795-2.292Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 200.307,
  cy: 29.949,
  r: 0.987,
  fill: "#000"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 213.142,
  cy: 29.455,
  r: 0.987,
  fill: "#000"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M188.707 141.267 165.752 304.17M168.961 136.823 141.81 302.936M200.307 139.292l17.031 91.818-34.555 65.902",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 167.973,
  cy: 106.217,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 182.783,
  cy: 89.927,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 188.706,
  cy: 107.698,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 201.541,
  cy: 91.408,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 165.505,
  cy: 91.408,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 189.694,
  cy: 73.143,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 161.556,
  cy: 72.156,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 174.884,
  cy: 62.283,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 206.478,
  cy: 109.673,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 209.933,
  cy: 77.586,
  r: 3.625,
  stroke: "#fff",
  strokeWidth: 2.129
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M184.017 60.062c-2.715 7.898-10.663 25.225-20.734 31.346M197.345 63.023c3.867 5.924 11.996 20.536 13.575 31.594",
  stroke: "#000",
  strokeWidth: 1.5
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "m106.179 14.438 5.804 3.752L88.72 57.818l-8.706-5.627 26.165-37.753ZM80.347 61.998c2.404 1.554 5.673.772 7.301-1.746l-8.706-5.628c-1.628 2.519-.999 5.82 1.405 7.374ZM111.741 10.75c.7-.307 1.485.2 1.492.964l.044 4.597-5.745-3.713 4.209-1.848Z",
  fill: "#FF9078"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "m289.986 161.676-36.412 27.97 21.916 28.27 14.496-56.24Z",
  fill: "#CEE1FB"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M154.051 314.347v5.924c10.531 2.88 31.445 10.071 30.853 15.797",
  stroke: "#fff",
  strokeWidth: 1.5
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M214.369 8c2.007.801 4.515.334 5.518 0 .418.5-.1 2.854-5.518 8.263-5.418 5.408-17.306 1.752-22.574-.752.251.334.803 2.404 1.004 8.013.2 5.608-5.268 5.842-8.027 5.258-.083-.25-.702-1.002-2.508-2.003-1.806-1.002-3.595-.752-4.264-.501",
  stroke: "#000",
  strokeWidth: 1.5
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 24.445,
  y: 120.898,
  width: 36.505,
  height: 36.505,
  rx: 9,
  transform: "rotate(-42.007 24.445 120.898)",
  fill: "#A7C6EF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 260.599,
  y: 26.787,
  width: 30.288,
  height: 47.856,
  rx: 3.158,
  transform: "rotate(-17.784 260.599 26.787)",
  fill: "#EFF3F9",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 267.326,
  cy: 34.237,
  r: 1.341,
  transform: "rotate(-17.784 267.326 34.237)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 269.54,
  cy: 41.141,
  r: 1.341,
  transform: "rotate(-17.784 269.54 41.141)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 271.755,
  cy: 48.045,
  r: 1.341,
  transform: "rotate(-17.784 271.755 48.045)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 273.969,
  cy: 54.949,
  r: 1.341,
  transform: "rotate(-17.784 273.969 54.949)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 276.183,
  cy: 61.852,
  r: 1.341,
  transform: "rotate(-17.784 276.183 61.852)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 260.257,
  y: 35.48,
  width: 6.971,
  height: 1.952,
  rx: 0.976,
  transform: "rotate(-17.784 260.257 35.48)",
  fill: "#000"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 262.471,
  y: 42.383,
  width: 6.971,
  height: 1.952,
  rx: 0.976,
  transform: "rotate(-17.784 262.471 42.383)",
  fill: "#000"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 264.686,
  y: 49.287,
  width: 6.971,
  height: 1.952,
  rx: 0.976,
  transform: "rotate(-17.784 264.686 49.287)",
  fill: "#000"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 266.9,
  y: 56.191,
  width: 6.971,
  height: 1.952,
  rx: 0.976,
  transform: "rotate(-17.784 266.9 56.19)",
  fill: "#000"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 269.114,
  y: 63.094,
  width: 6.971,
  height: 1.952,
  rx: 0.976,
  transform: "rotate(-17.784 269.114 63.094)",
  fill: "#000"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#A7C6EF",
  d: "m271.003 28.812 15.134-4.855 3.864 12.046-15.134 4.855z"
})));
export default SvgGetStarted1;